// Demo data management - client-side only
import { toast } from "sonner";
import { safeStorage } from '@/lib/safeStorage';
import josephAvatar from '@/assets/chat-joseph.png';
import yoikiAvatar from '@/assets/chat-yoiki.png';
import chanAvatar from '@/assets/chat-chan.png';
import profAvatar from '@/assets/chat-prof.png';
import mojoAvatar from '@/assets/chat-mojo.png';
import freshmanAvatar from '@/assets/chat-freshman.png';
import item1 from '@/assets/chat-item-1.png';
import item2 from '@/assets/chat-item-2.png';
import item3 from '@/assets/chat-item-3.png';

export const DEMO_LISTINGS_KEY = "gemurhood_demo_listings";
export const DEMO_POSTS_KEY = "gemurhood_demo_posts";
export const DEMO_CHAT_CONVERSATIONS_KEY = "gemurhood_demo_chat_conversations";
const DEMO_DATA_VERSION = "5.0"; // Increment when demo data changes
const DEMO_DATA_VERSION_KEY = "gemurhood_demo_data_version";

// Define base times for stable ordering - each listing has distinct time
const NOW = Date.now();
const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;

export const DEMO_LISTINGS = [
  {
    id: "demo-listing-1",
    title: "Airpod Pro 2",
    price: 120,
    category: "goods",
    location: "Ecorse, Wayne County",
    county: "Wayne",
    township: "Ecorse Township",
    images: ["https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?w=400"],
    description: "Gently used AirPods Pro 2. Comes with original case and all accessories. Great sound quality!",
    seller_id: "demo-seller-1",
    created_at: new Date(NOW - 3 * DAY).toISOString(),
    content_updated_at: new Date(NOW - 3 * DAY).toISOString(),
    likes: 11,
    chats: 3,
    latitude: 42.245,
    longitude: -83.173,
    seller: {
      id: "demo-seller-1",
      name: "Joseph",
      username: "joseph_trades",
      county: "Ann Arbor",
      verified: true,
    },
  },
  {
    id: "demo-listing-2",
    title: "Byredo Blanche EDP 50ml",
    price: 90,
    category: "goods",
    location: "Livonia, Wayne County",
    county: "Wayne",
    township: "Livonia Township",
    images: ["https://images.unsplash.com/photo-1541643600914-78b084683601?w=400"],
    description: "Authentic Byredo Blanche EDP 50ml. 80% full. Beautiful fresh scent.",
    seller_id: "demo-seller-2",
    created_at: new Date(NOW - 2 * DAY).toISOString(),
    content_updated_at: new Date(NOW - 2 * DAY).toISOString(),
    likes: 2,
    chats: 0,
    latitude: 42.368,
    longitude: -83.373,
    seller: {
      id: "demo-seller-2",
      name: "Emily",
      username: "emily_beauty",
      county: "Washtenaw",
      verified: true,
    },
  },
  {
    id: "demo-listing-3",
    title: "Sandwich",
    price: 12,
    category: "goods",
    location: "Ann Arbor Charter Township, Washtenaw County",
    county: "Washtenaw",
    township: "Ann Arbor Charter Township",
    images: ["https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400"],
    description: "Freshly made gourmet sandwich. Pick up today!",
    seller_id: "demo-seller-3",
    created_at: new Date(NOW - 1 * DAY).toISOString(),
    content_updated_at: new Date(NOW - 1 * DAY).toISOString(),
    likes: 0,
    chats: 0,
    latitude: 42.281,
    longitude: -83.743,
    seller: {
      id: "demo-seller-3",
      name: "Kari",
      username: "kari_foodie",
      county: "Saline",
      verified: false,
    },
  },
  {
    id: "demo-listing-4",
    title: "iPhone 13 Pro Max",
    price: 1000,
    category: "goods",
    location: "Superior Charter Township, Washtenaw County",
    county: "Washtenaw",
    township: "Superior Charter Township",
    images: ["https://images.unsplash.com/photo-1632661674596-df8be070a5c5?w=400"],
    description: "iPhone 13 Pro Max in excellent condition. 256GB, Sierra Blue. No scratches, always kept in case.",
    seller_id: "demo-seller-1",
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 3,
    chats: 0,
    latitude: 42.178,
    longitude: -83.267,
    seller: {
      id: "demo-seller-1",
      name: "Joseph",
      username: "joseph_trades",
      county: "Ann Arbor",
      verified: true,
    },
  },
  {
    id: "demo-listing-5",
    title: "Coffee Machine",
    price: 870,
    category: "goods",
    location: "Ypsilanti Charter Township, Washtenaw County",
    county: "Washtenaw",
    township: "Ypsilanti Charter Township",
    images: ["https://images.unsplash.com/photo-1517668808822-9ebb02f2a0e6?w=400"],
    description: "Professional espresso machine. Perfect for home baristas. Barely used.",
    seller_id: "demo-seller-4",
    created_at: new Date(Date.now() - 1000).toISOString(),
    likes: 0,
    chats: 0,
    latitude: 42.125,
    longitude: -83.143,
    seller: {
      id: "demo-seller-4",
      name: "Kristin",
      username: "kristin_local",
      county: "Ypsilanti Township",
      verified: true,
    },
  },
  {
    id: "demo-listing-6",
    title: "Vintage Guitar",
    price: 450,
    category: "goods",
    location: "Pittsfield Charter Township, Washtenaw County",
    county: "Washtenaw",
    township: "Pittsfield Charter Township",
    images: ["https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=400"],
    description: "Beautiful vintage acoustic guitar in excellent condition.",
    seller_id: "demo-seller-3",
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 5,
    chats: 2,
    latitude: 42.253,
    longitude: -83.718,
    seller: {
      id: "demo-seller-3",
      name: "Kari",
      username: "kari_foodie",
      county: "Saline",
      verified: false,
    },
  },
  {
    id: "demo-listing-7",
    title: "Designer Sofa",
    price: 600,
    category: "goods",
    location: "Monroe Charter Township, Monroe County",
    county: "Monroe",
    township: "Monroe Charter Township",
    images: ["https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400"],
    description: "Modern 3-seater sofa in perfect condition. Must pick up.",
    seller_id: "demo-seller-2",
    created_at: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    likes: 7,
    chats: 4,
    latitude: 41.916,
    longitude: -83.398,
    seller: {
      id: "demo-seller-2",
      name: "Emily",
      username: "emily_beauty",
      county: "Washtenaw",
      verified: true,
    },
  },
  {
    id: "demo-listing-8",
    title: "Gaming Monitor",
    price: 250,
    category: "goods",
    location: "Brighton Township, Livingston County",
    county: "Livingston",
    township: "Brighton Township",
    images: ["https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=400"],
    description: "27-inch 144Hz gaming monitor. Perfect for gaming and work.",
    seller_id: "demo-seller-1",
    created_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    likes: 4,
    chats: 2,
    latitude: 42.529,
    longitude: -83.780,
    seller: {
      id: "demo-seller-1",
      name: "Joseph",
      username: "joseph_trades",
      county: "Ann Arbor",
      verified: true,
    },
  },
  {
    id: "demo-listing-9",
    title: "Mountain Bike",
    price: 400,
    category: "goods",
    location: "Howell Township, Livingston County",
    county: "Livingston",
    township: "Howell Township",
    images: ["https://images.unsplash.com/photo-1576435728678-68d0fbf94e91?w=400"],
    description: "Trek mountain bike in great shape. Rarely used.",
    seller_id: "demo-seller-3",
    created_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    likes: 6,
    chats: 3,
    latitude: 42.607,
    longitude: -83.929,
    seller: {
      id: "demo-seller-3",
      name: "Kari",
      username: "kari_foodie",
      county: "Saline",
      verified: false,
    },
  },
  {
    id: "demo-listing-10",
    title: "iPad Pro 11\"",
    price: 550,
    category: "goods",
    location: "Novi Township, Oakland County",
    county: "Oakland",
    township: "Novi Township",
    images: ["https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=400"],
    description: "iPad Pro 11-inch with Apple Pencil. Excellent condition.",
    seller_id: "demo-seller-4",
    created_at: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    likes: 8,
    chats: 5,
    latitude: 42.481,
    longitude: -83.476,
    seller: {
      id: "demo-seller-4",
      name: "Kristin",
      username: "kristin_local",
      county: "Ypsilanti Township",
      verified: true,
    },
  },
  {
    id: "demo-listing-11",
    title: "Leather Jacket",
    price: 180,
    category: "goods",
    location: "West Bloomfield Charter Township, Oakland County",
    county: "Oakland",
    township: "West Bloomfield Charter Township",
    images: ["https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400"],
    description: "Genuine leather jacket, size M. Like new condition.",
    seller_id: "demo-seller-2",
    created_at: new Date(Date.now() - 18 * 60 * 60 * 1000).toISOString(),
    likes: 3,
    chats: 1,
    latitude: 42.566,
    longitude: -83.383,
    seller: {
      id: "demo-seller-2",
      name: "Emily",
      username: "emily_beauty",
      county: "Washtenaw",
      verified: true,
    },
  },
  {
    id: "demo-listing-12",
    title: "Power Drill Set",
    price: 85,
    category: "goods",
    location: "Blackman Charter Township, Jackson County",
    county: "Jackson",
    township: "Blackman Charter Township",
    images: ["https://images.unsplash.com/photo-1504148455328-c376907d081c?w=400"],
    description: "Complete power drill set with various bits and case.",
    seller_id: "demo-seller-1",
    created_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    likes: 2,
    chats: 1,
    latitude: 42.246,
    longitude: -84.401,
    seller: {
      id: "demo-seller-1",
      name: "Joseph",
      username: "joseph_trades",
      county: "Ann Arbor",
      verified: true,
    },
  },
  {
    id: "demo-listing-13",
    title: "Running Shoes Nike",
    price: 60,
    category: "goods",
    location: "Adrian Charter Township, Lenawee County",
    county: "Lenawee",
    township: "Adrian Charter Township",
    images: ["https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400"],
    description: "Nike running shoes, size 10. Barely worn, excellent condition.",
    seller_id: "demo-seller-3",
    created_at: new Date(Date.now() - 36 * 60 * 60 * 1000).toISOString(),
    likes: 1,
    chats: 0,
    latitude: 41.897,
    longitude: -84.037,
    seller: {
      id: "demo-seller-3",
      name: "Kari",
      username: "kari_foodie",
      county: "Saline",
      verified: false,
    },
  },
  // Wayne County (3개)
  {
    id: "demo-listing-new-1",
    title: "2019 Toyota Camry LE",
    price: 18500,
    category: "goods",
    subcategory: "usedCars",
    location: "Detroit, Wayne County",
    county: "Wayne",
    location_type: "City",
    city: "Detroit",
    township: null,
    images: ["https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=400"],
    description: "2019 Toyota Camry LE in excellent condition. 45k miles, single owner. Full service history, clean title. Great fuel economy!",
    seller_id: "demo-seller-5",
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 12,
    chats: 5,
    latitude: 42.3314,
    longitude: -83.0458,
    seller: {
      id: "demo-seller-5",
      name: "Mike",
      username: "mike_autos",
      county: "Wayne",
      verified: true,
    },
  },
  {
    id: "demo-listing-new-2",
    title: "한식당 Chef 구합니다",
    price: 0,
    category: "services",
    subcategory: "wanted",
    location: "Livonia, Wayne County",
    county: "Wayne",
    location_type: "City",
    city: "Livonia",
    township: null,
    images: ["https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400"],
    description: "Busy Korean restaurant seeking experienced chef. Must know traditional Korean dishes. Competitive pay, flexible hours. Contact for details.",
    seller_id: "demo-seller-6",
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 8,
    chats: 4,
    latitude: 42.3684,
    longitude: -83.3527,
    seller: {
      id: "demo-seller-6",
      name: "Jane Kim",
      username: "janekim_resto",
      county: "Wayne",
      verified: true,
    },
  },
  {
    id: "demo-listing-new-3",
    title: "Professional Plumbing Services",
    price: 85,
    category: "services",
    subcategory: "experts",
    location: "Canton Charter Township, Wayne County",
    county: "Wayne",
    location_type: "Township",
    city: null,
    township: "Canton Charter Township",
    images: ["https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=400"],
    description: "Licensed plumber with 15+ years experience. Residential and commercial. Emergency services available. $85/hr, free estimates!",
    seller_id: "demo-seller-7",
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 15,
    chats: 8,
    latitude: 42.3087,
    longitude: -83.4816,
    seller: {
      id: "demo-seller-7",
      name: "Tom Harris",
      username: "tom_plumbing",
      county: "Wayne",
      verified: true,
    },
  },
  // Monroe County (3개)
  {
    id: "demo-listing-new-4",
    title: "Vintage Leather Jacket - Men's L",
    price: 150,
    category: "goods",
    subcategory: "usedGoods",
    location: "Monroe, Monroe County",
    county: "Monroe",
    location_type: "City",
    city: "Monroe",
    township: null,
    images: ["https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400"],
    description: "Genuine leather vintage jacket. Classic brown color, size Large. Gently worn, perfect condition. Timeless style!",
    seller_id: "demo-seller-8",
    created_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 6,
    chats: 2,
    latitude: 41.9165,
    longitude: -83.3977,
    seller: {
      id: "demo-seller-8",
      name: "Chris",
      username: "chris_vintage",
      county: "Monroe",
      verified: false,
    },
  },
  {
    id: "demo-listing-new-5",
    title: "2016 Ford F-150 XLT Pickup",
    price: 24000,
    category: "goods",
    subcategory: "usedCars",
    location: "Bedford Township, Monroe County",
    county: "Monroe",
    location_type: "Township",
    city: null,
    township: "Bedford Township",
    images: ["https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400"],
    description: "2016 Ford F-150 XLT, 4WD, V8 engine. 72k miles, well maintained. Perfect work truck, clean interior. No accidents!",
    seller_id: "demo-seller-9",
    created_at: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 18,
    chats: 7,
    latitude: 41.9325,
    longitude: -83.5274,
    seller: {
      id: "demo-seller-9",
      name: "Dave",
      username: "dave_trucks",
      county: "Monroe",
      verified: true,
    },
  },
  {
    id: "demo-listing-new-6",
    title: "Piano Lessons - All Ages Welcome",
    price: 50,
    category: "services",
    subcategory: "experts",
    location: "Monroe, Monroe County",
    county: "Monroe",
    location_type: "City",
    city: "Monroe",
    township: null,
    images: ["https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=400"],
    description: "Experienced piano teacher offering lessons for beginners to advanced. Classical and contemporary styles. $50/hour, first lesson free!",
    seller_id: "demo-seller-10",
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 10,
    chats: 6,
    latitude: 41.9165,
    longitude: -83.3977,
    seller: {
      id: "demo-seller-10",
      name: "Sarah",
      username: "sarah_music",
      county: "Monroe",
      verified: true,
    },
  },
  // Livingston County (3개)
  {
    id: "demo-listing-new-7",
    title: "Weber Genesis Gas Grill",
    price: 280,
    category: "goods",
    subcategory: "usedGoods",
    location: "Brighton, Livingston County",
    county: "Livingston",
    location_type: "City",
    city: "Brighton",
    township: null,
    images: ["https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400"],
    description: "Weber Genesis II gas grill. 3 burners, side burner included. Barely used, like new condition. Great for summer BBQs!",
    seller_id: "demo-seller-11",
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 9,
    chats: 3,
    latitude: 42.5295,
    longitude: -83.7803,
    seller: {
      id: "demo-seller-11",
      name: "Brad",
      username: "brad_grillmaster",
      county: "Livingston",
      verified: false,
    },
  },
  {
    id: "demo-listing-new-8",
    title: "2 Bedroom Apartment for Rent",
    price: 1250,
    category: "goods",
    subcategory: "realEstate",
    location: "Genoa Charter Township, Livingston County",
    county: "Livingston",
    location_type: "Township",
    city: null,
    township: "Genoa Charter Township",
    images: ["https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=400"],
    description: "Beautiful 2BR/2BA apartment. Modern kitchen, in-unit laundry, parking included. Quiet neighborhood. $1,250/month + utilities.",
    seller_id: "demo-seller-12",
    created_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 14,
    chats: 9,
    latitude: 42.5533,
    longitude: -83.9278,
    seller: {
      id: "demo-seller-12",
      name: "Linda",
      username: "linda_realty",
      county: "Livingston",
      verified: true,
    },
  },
  {
    id: "demo-listing-new-9",
    title: "Lawn Care & Landscaping",
    price: 40,
    category: "services",
    subcategory: "neighborhood",
    location: "Brighton, Livingston County",
    county: "Livingston",
    location_type: "City",
    city: "Brighton",
    township: null,
    images: ["https://images.unsplash.com/photo-1558904541-efa843a96f01?w=400"],
    description: "Professional lawn mowing and landscaping services. Weekly maintenance, mulching, hedge trimming. $40/week, reliable service!",
    seller_id: "demo-seller-13",
    created_at: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 7,
    chats: 4,
    latitude: 42.5295,
    longitude: -83.7803,
    seller: {
      id: "demo-seller-13",
      name: "Carlos",
      username: "carlos_lawn",
      county: "Livingston",
      verified: true,
    },
  },
  // Oakland County (3개)
  {
    id: "demo-listing-new-10",
    title: "MacBook Pro 14\" M3 (2024)",
    price: 1800,
    category: "goods",
    subcategory: "usedGoods",
    location: "Troy, Oakland County",
    county: "Oakland",
    location_type: "City",
    city: "Troy",
    township: null,
    images: ["https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400"],
    description: "MacBook Pro 14\" with M3 chip, 16GB RAM, 512GB SSD. Like new, barely used. Comes with original box and charger. AppleCare+ included!",
    seller_id: "demo-seller-14",
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 22,
    chats: 11,
    latitude: 42.6064,
    longitude: -83.1498,
    seller: {
      id: "demo-seller-14",
      name: "Alex",
      username: "alex_tech",
      county: "Oakland",
      verified: true,
    },
  },
  {
    id: "demo-listing-new-11",
    title: "Luxury 1BR Condo for Rent",
    price: 2100,
    category: "goods",
    subcategory: "realEstate",
    location: "Bloomfield Charter Township, Oakland County",
    county: "Oakland",
    location_type: "Township",
    city: null,
    township: "Bloomfield Charter Township",
    images: ["https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400"],
    description: "Stunning luxury condo in Bloomfield. Granite counters, hardwood floors, pool & gym access. $2,100/month. Available immediately!",
    seller_id: "demo-seller-15",
    created_at: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 25,
    chats: 12,
    latitude: 42.5570,
    longitude: -83.2677,
    seller: {
      id: "demo-seller-15",
      name: "Patricia",
      username: "patricia_homes",
      county: "Oakland",
      verified: true,
    },
  },
  {
    id: "demo-listing-new-12",
    title: "Professional Dog Grooming",
    price: 60,
    category: "services",
    subcategory: "neighborhood",
    location: "Royal Oak, Oakland County",
    county: "Oakland",
    location_type: "City",
    city: "Royal Oak",
    township: null,
    images: ["https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=400"],
    description: "Certified dog groomer. Full grooming packages including bath, haircut, nail trim. All breeds welcome! $60/session, book today!",
    seller_id: "demo-seller-16",
    created_at: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 11,
    chats: 6,
    latitude: 42.4895,
    longitude: -83.1446,
    seller: {
      id: "demo-seller-16",
      name: "Rachel",
      username: "rachel_petspa",
      county: "Oakland",
      verified: true,
    },
  },
  // Jackson County (3개)
  {
    id: "demo-listing-new-13",
    title: "Herman Miller Aeron Chair",
    price: 450,
    category: "goods",
    subcategory: "usedGoods",
    location: "Jackson, Jackson County",
    county: "Jackson",
    location_type: "City",
    city: "Jackson",
    township: null,
    images: ["https://images.unsplash.com/photo-1580480055273-228ff5388ef8?w=400"],
    description: "Authentic Herman Miller Aeron chair, size B. Excellent ergonomic support. Gently used home office chair. Worth $1,500 new!",
    seller_id: "demo-seller-17",
    created_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 13,
    chats: 5,
    latitude: 42.2459,
    longitude: -84.4013,
    seller: {
      id: "demo-seller-17",
      name: "Steve",
      username: "steve_office",
      county: "Jackson",
      verified: false,
    },
  },
  {
    id: "demo-listing-new-14",
    title: "2017 Jeep Wrangler Unlimited",
    price: 28000,
    category: "goods",
    subcategory: "usedCars",
    location: "Blackman Charter Township, Jackson County",
    county: "Jackson",
    location_type: "Township",
    city: null,
    township: "Blackman Charter Township",
    images: ["https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=400"],
    description: "2017 Jeep Wrangler Unlimited Sahara. 4WD, hardtop, 55k miles. Perfect for off-roading! Well maintained, clean title.",
    seller_id: "demo-seller-18",
    created_at: new Date(Date.now() - 13 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 20,
    chats: 8,
    latitude: 42.2173,
    longitude: -84.3686,
    seller: {
      id: "demo-seller-18",
      name: "Mark",
      username: "mark_jeeps",
      county: "Jackson",
      verified: true,
    },
  },
  {
    id: "demo-listing-new-15",
    title: "Handyman 구합니다",
    price: 0,
    category: "services",
    subcategory: "wanted",
    location: "Jackson, Jackson County",
    county: "Jackson",
    location_type: "City",
    city: "Jackson",
    township: null,
    images: ["https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400"],
    description: "Need a reliable handyman for home repairs. Drywall, painting, minor plumbing. Flexible schedule. Competitive pay, ongoing work available!",
    seller_id: "demo-seller-19",
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 5,
    chats: 3,
    latitude: 42.2459,
    longitude: -84.4013,
    seller: {
      id: "demo-seller-19",
      name: "Nancy",
      username: "nancy_homeowner",
      county: "Jackson",
      verified: false,
    },
  },
  // Lenawee County (3개)
  {
    id: "demo-listing-new-16",
    title: "Yamaha FG800 Acoustic Guitar",
    price: 220,
    category: "goods",
    subcategory: "usedGoods",
    location: "Adrian, Lenawee County",
    county: "Lenawee",
    location_type: "City",
    city: "Adrian",
    township: null,
    images: ["https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=400"],
    description: "Yamaha FG800 acoustic guitar in great condition. Perfect for beginners or intermediate players. Comes with case and extra strings!",
    seller_id: "demo-seller-20",
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 8,
    chats: 4,
    latitude: 41.8975,
    longitude: -84.0372,
    seller: {
      id: "demo-seller-20",
      name: "Jason",
      username: "jason_music",
      county: "Lenawee",
      verified: false,
    },
  },
  {
    id: "demo-listing-new-17",
    title: "3 Bedroom House for Rent",
    price: 1400,
    category: "goods",
    subcategory: "realEstate",
    location: "Tecumseh, Lenawee County",
    county: "Lenawee",
    location_type: "City",
    city: "Tecumseh",
    township: null,
    images: ["https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=400"],
    description: "Charming 3BR/2BA house in quiet neighborhood. Large backyard, 2-car garage, updated appliances. $1,400/month. Pets negotiable!",
    seller_id: "demo-seller-21",
    created_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 16,
    chats: 10,
    latitude: 42.0034,
    longitude: -83.9447,
    seller: {
      id: "demo-seller-21",
      name: "Susan",
      username: "susan_rentals",
      county: "Lenawee",
      verified: true,
    },
  },
  {
    id: "demo-listing-new-18",
    title: "Math & Science Tutor",
    price: 45,
    category: "services",
    subcategory: "experts",
    location: "Adrian, Lenawee County",
    county: "Lenawee",
    location_type: "City",
    city: "Adrian",
    township: null,
    images: ["https://images.unsplash.com/photo-1509062522246-3755977927d7?w=400"],
    description: "Experienced math and science tutor. Middle school to high school levels. Algebra, geometry, chemistry, physics. $45/hour, results guaranteed!",
    seller_id: "demo-seller-22",
    created_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    likes: 12,
    chats: 7,
    latitude: 41.8975,
    longitude: -84.0372,
    seller: {
      id: "demo-seller-22",
      name: "Robert",
      username: "robert_tutor",
      county: "Lenawee",
      verified: true,
    },
  },
];

export const DEMO_POSTS = [
  // ===== PINNED / AD POST =====
  {
    id: "demo-post-1",
    topic: "Local News",
    action: "localInfo",
    category: "localInfo",
    title: "Emily's Michigan 〽️💙✨ Life on Gemurhood!",
    body: "Jay, check out what's happening now!",
    author_id: "demo-user-2",
    area: "Washtenaw",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    agree_count: 12,
    curious_count: 3,
    replies_count: 0,
    is_ad: true,
    is_demo: true,
  },

  // ===== 📰 LOCAL INFO (3 posts) =====
  {
    id: "demo-post-li-1",
    topic: "Local Info",
    action: "localInfo",
    category: "localInfo",
    body: "Heads up — they're repaving Washtenaw Ave between Stadium and Huron. Expect delays through Friday. I've been taking Packard as a detour and it's been fine.",
    author_id: "demo-user-10",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 25 * 60 * 1000).toISOString(),
    agree_count: 18,
    curious_count: 4,
    replies_count: 7,
    is_demo: true,
  },
  {
    id: "demo-post-li-2",
    topic: "Local Info",
    action: "localInfo",
    category: "localInfo",
    title: "New Korean grocery near Carpenter Rd",
    body: "Just opened last week! They have fresh banchan, imported snacks, and a tiny food court inside. Prices are really reasonable compared to H Mart. The ajumma running the place is super friendly.",
    author_id: "demo-user-11",
    area: "Pittsfield Township",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 2 * HOUR).toISOString(),
    agree_count: 31,
    curious_count: 8,
    replies_count: 12,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400",
  },
  {
    id: "demo-post-li-3",
    topic: "Local Info",
    action: "localInfo",
    category: "localInfo",
    body: "PSA: The city is doing free bulk trash pickup next Saturday in Ward 5. You can leave up to 4 large items curbside. Finally getting rid of that broken futon 🎉",
    author_id: "demo-user-40",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 5 * HOUR).toISOString(),
    agree_count: 22,
    curious_count: 3,
    replies_count: 9,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1567306226416-28f0efdc88ce?w=400",
  },

  // ===== 🎨 HOBBIES (3 posts) =====
  {
    id: "demo-post-ho-1",
    topic: "Hobbies",
    action: "hobbies",
    category: "hobbies",
    title: "Anyone into film photography here?",
    body: "I just got a secondhand Pentax K1000 and I'm hooked. Shot my first roll of Portra 400 around the Arb last weekend. Where do you guys get film developed locally? Mail-in feels sketchy.",
    author_id: "demo-user-13",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 40 * 60 * 1000).toISOString(),
    agree_count: 14,
    curious_count: 6,
    replies_count: 8,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1495745966610-2a67f2297e5e?w=400",
  },
  {
    id: "demo-post-ho-2",
    topic: "Hobbies",
    action: "hobbies",
    category: "hobbies",
    body: "Started a little herb garden on my apartment balcony. Basil and mint are thriving but cilantro keeps bolting. Any tips from fellow balcony gardeners? 🌿",
    author_id: "demo-user-14",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 3 * HOUR).toISOString(),
    agree_count: 9,
    curious_count: 2,
    replies_count: 6,
    is_demo: true,
  },
  {
    id: "demo-post-ho-3",
    topic: "Hobbies",
    action: "hobbies",
    category: "hobbies",
    title: "Board game night at Vault of Midnight",
    body: "They do open gaming every Thursday 6-10pm. Brought my own copy of Wingspan last week and had a blast with strangers. Highly recommend if you're looking for something chill to do on a weeknight.",
    author_id: "demo-user-15",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 1 * DAY).toISOString(),
    agree_count: 14,
    curious_count: 5,
    replies_count: 3,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1610890716171-6b1bb98ffd09?w=400",
  },

  // ===== 🎓 CAMPUS (3 posts) =====
  {
    id: "demo-post-ca-1",
    topic: "Campus",
    action: "campus",
    category: "campus",
    body: "Is the UGLI actually a good study spot or is it just always packed? I'm a freshman trying to find quiet places that aren't the fishbowl. The 3rd floor of Hatcher has been my secret but it's getting crowded too 😩",
    author_id: "demo-user-16",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 30 * 60 * 1000).toISOString(),
    agree_count: 8,
    curious_count: 1,
    replies_count: 11,
    is_demo: true,
  },
  {
    id: "demo-post-ca-2",
    topic: "Campus",
    action: "campus",
    category: "campus",
    title: "Prof. Kim's EECS 281 curve is WILD",
    body: "The median on the last exam was a 42%. Entire lecture hall was in shambles. He said 'this is expected' with a straight face. I love and hate this school simultaneously.",
    author_id: "demo-user-17",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 6 * HOUR).toISOString(),
    agree_count: 52,
    curious_count: 7,
    replies_count: 23,
    is_demo: true,
  },
  {
    id: "demo-post-ca-3",
    topic: "Campus",
    action: "campus",
    category: "campus",
    body: "Graduated last May and honestly miss campus so much. Walked through the Diag yesterday and got hit with nostalgia. Enjoy it while you can, undergrads. It goes by fast. 🎓",
    author_id: "demo-user-41",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 1 * DAY - 4 * HOUR).toISOString(),
    agree_count: 38,
    curious_count: 2,
    replies_count: 15,
    is_demo: true,
  },

  // ===== 🛠️ SERVICES (3 posts) =====
  {
    id: "demo-post-sv-1",
    topic: "Services",
    action: "services",
    category: "services",
    title: "Reliable mechanic near downtown?",
    body: "My 2018 Civic needs brake pads and rotors replaced. The dealership quoted me $800 which feels insane. Anyone know a trustworthy independent shop? Last time I went to a random place on Yelp they tried to upsell me on stuff I didn't need.",
    author_id: "demo-user-19",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 45 * 60 * 1000).toISOString(),
    agree_count: 4,
    curious_count: 2,
    replies_count: 9,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=400",
  },
  {
    id: "demo-post-sv-2",
    topic: "Services",
    action: "services",
    category: "services",
    body: "Offering free resume reviews this week! I'm a career coach with 10+ years of experience. DM me a PDF and I'll give detailed feedback within 48 hours. Paying it forward since someone did this for me when I was job hunting 🙏",
    author_id: "demo-user-20",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 8 * HOUR).toISOString(),
    agree_count: 19,
    curious_count: 6,
    replies_count: 14,
    is_demo: true,
  },
  {
    id: "demo-post-sv-3",
    topic: "Services",
    action: "services",
    category: "services",
    body: "I'm a retired electrician. If anyone in the neighborhood needs help with basic electrical stuff — swapping outlets, installing ceiling fans, etc. — I'm happy to help for free. Just brings me joy to stay useful. DM me 🔧",
    author_id: "demo-user-42",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 2 * DAY).toISOString(),
    agree_count: 45,
    curious_count: 3,
    replies_count: 11,
    is_demo: true,
  },

  // ===== 🆘 HELP (3 posts) =====
  {
    id: "demo-post-he-1",
    topic: "Help",
    action: "help",
    category: "help",
    title: "Lost gray tabby cat near Burns Park 😭",
    body: "His name is Mochi, he's microchipped and neutered. Last seen near Baldwin Ave around 6pm yesterday. He's an indoor cat who snuck out when we were bringing in groceries. Please DM if you see him.",
    author_id: "demo-user-22",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    status: "Seeking",
    created_at: new Date(NOW - 20 * 60 * 1000).toISOString(),
    agree_count: 35,
    curious_count: 12,
    replies_count: 8,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=400",
  },
  {
    id: "demo-post-he-2",
    topic: "Help",
    action: "help",
    category: "help",
    body: "Does anyone have a truck or SUV I could borrow for 2 hours this Saturday? Bought a couch off marketplace and need to get it from Ypsi to my apartment. Happy to pay for gas + pizza 🍕",
    author_id: "demo-user-23",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 4 * HOUR).toISOString(),
    agree_count: 2,
    curious_count: 0,
    replies_count: 5,
    is_demo: true,
  },
  {
    id: "demo-post-he-3",
    topic: "Help",
    action: "help",
    category: "help",
    title: "Found set of keys near Kerrytown",
    body: "Found a keychain with a blue Subaru fob and about 5 keys near the Saturday farmers market. Has a little Michigan keychain on it. DM me to describe and claim!",
    author_id: "demo-user-24",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 1 * DAY - 2 * HOUR).toISOString(),
    agree_count: 8,
    curious_count: 1,
    replies_count: 3,
    is_demo: true,
  },

  // ===== ❓ Q&A (3 posts) =====
  {
    id: "demo-post-qa-1",
    topic: "Q&A",
    action: "qna",
    category: "qna",
    body: "How much does parking actually cost downtown? Got a new job on Main St and trying to figure out if the monthly garage pass ($150/mo) is worth it vs. street parking lottery every morning.",
    author_id: "demo-user-25",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    status: "Question",
    created_at: new Date(NOW - 35 * 60 * 1000).toISOString(),
    agree_count: 7,
    curious_count: 4,
    replies_count: 13,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1506521781263-d8422e82f27a?w=400",
  },
  {
    id: "demo-post-qa-2",
    topic: "Q&A",
    action: "qna",
    category: "qna",
    title: "Best internet provider in Ann Arbor?",
    body: "Moving to a new apartment near Briarwood. Is AT&T fiber available everywhere or just certain areas? Comcast has been absolute trash at my current spot. WFH so I need reliable 100+ Mbps.",
    author_id: "demo-user-26",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    status: "Question",
    created_at: new Date(NOW - 7 * HOUR).toISOString(),
    agree_count: 11,
    curious_count: 6,
    replies_count: 16,
    is_demo: true,
  },
  {
    id: "demo-post-qa-3",
    topic: "Q&A",
    action: "qna",
    category: "qna",
    body: "What's the deal with the Ann Arbor Art Fair? Is it worth going or is it just overpriced crafts and crowds? First summer here and everyone keeps telling me it's a 'must' but idk.",
    author_id: "demo-user-43",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    status: "Question",
    created_at: new Date(NOW - 2 * DAY - 3 * HOUR).toISOString(),
    agree_count: 15,
    curious_count: 9,
    replies_count: 21,
    is_demo: true,
  },

  // ===== ✨ LIFESTYLE (3 posts) =====
  {
    id: "demo-post-ls-1",
    topic: "Lifestyle",
    action: "lifestyle",
    category: "lifestyle",
    body: "Unpopular opinion: the best coffee in Ann Arbor isn't Zingerman's or Roos Roast — it's the random cart outside the Michigan Union on Tuesday mornings. Fight me ☕",
    author_id: "demo-user-28",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 50 * 60 * 1000).toISOString(),
    agree_count: 24,
    curious_count: 7,
    replies_count: 19,
    is_demo: true,
  },
  {
    id: "demo-post-ls-2",
    topic: "Lifestyle",
    action: "lifestyle",
    category: "lifestyle",
    title: "71 years old and just finished my first 5K 🏃‍♂️",
    body: "Signed up for the Dexter-Ann Arbor Run on a dare from my granddaughter. Trained for 3 months, walked most of it, but I finished! Never too old to try something new. If this old man can do it, so can you.",
    author_id: "demo-user-44",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 10 * HOUR).toISOString(),
    agree_count: 89,
    curious_count: 3,
    replies_count: 24,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1571008887538-b36bb32f4571?w=400",
  },
  {
    id: "demo-post-ls-3",
    topic: "Lifestyle",
    action: "lifestyle",
    category: "lifestyle",
    body: "Meal prepping saved me so much money this month. Went from $400/mo eating out to about $180 on groceries. Trader Joe's frozen section is an absolute cheat code. If anyone wants my weekly meal plan template, DM me!",
    author_id: "demo-user-30",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 1 * DAY - 8 * HOUR).toISOString(),
    agree_count: 16,
    curious_count: 2,
    replies_count: 8,
    is_demo: true,
  },

  // ===== 😂 FUNNY (3 posts) =====
  {
    id: "demo-post-fu-1",
    topic: "Funny",
    action: "funny",
    category: "funny",
    body: "Just watched a squirrel on the Diag steal an entire bagel from someone's backpack, sprint up a tree, and eat it while making eye contact. Michigan squirrels are built different 🐿️",
    author_id: "demo-user-31",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 15 * 60 * 1000).toISOString(),
    agree_count: 67,
    curious_count: 4,
    replies_count: 22,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1474511320723-9a56873571b7?w=400",
  },
  {
    id: "demo-post-fu-2",
    topic: "Funny",
    action: "funny",
    category: "funny",
    body: "My neighbor has been playing \"Don't Stop Believin'\" on repeat since 7am. It's currently 2pm. I started with annoyance, moved to acceptance, and now I genuinely believe. The song works.",
    author_id: "demo-user-32",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 5 * HOUR).toISOString(),
    agree_count: 43,
    curious_count: 8,
    replies_count: 15,
    is_demo: true,
  },
  {
    id: "demo-post-fu-3",
    topic: "Funny",
    action: "funny",
    category: "funny",
    title: "The parking meter drama 🎭",
    body: "Ran to my car with 30 seconds left on the meter. Made it just in time to watch the parking officer ALREADY writing the ticket. We locked eyes. She kept writing. $45 gone. This is my villain origin story.",
    author_id: "demo-user-33",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 2 * DAY - 1 * HOUR).toISOString(),
    agree_count: 89,
    curious_count: 2,
    replies_count: 31,
    is_demo: true,
  },

  // ===== 💬 ANY TALK (3 posts) =====
  {
    id: "demo-post-at-1",
    topic: "Any Talk",
    action: "anyTalk",
    category: "anyTalk",
    body: "Just got laid off after 12 years at the same company. Honestly don't even know where to start. Anyone else gone through this? How did you handle it? Feeling pretty lost right now.",
    author_id: "demo-user-34",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 1 * HOUR).toISOString(),
    agree_count: 34,
    curious_count: 3,
    replies_count: 27,
    is_demo: true,
  },
  {
    id: "demo-post-at-2",
    topic: "Any Talk",
    action: "anyTalk",
    category: "anyTalk",
    body: "I'm a professor at UM and I just want to say — if you're struggling in class, PLEASE come to office hours. We're not scary. Most of us genuinely want to help. The empty chairs make me sad lol",
    author_id: "demo-user-45",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 9 * HOUR).toISOString(),
    agree_count: 72,
    curious_count: 5,
    replies_count: 18,
    is_demo: true,
  },
  {
    id: "demo-post-at-3",
    topic: "Any Talk",
    action: "anyTalk",
    category: "anyTalk",
    title: "What's your go-to comfort food spot?",
    body: "Having one of those days. Need somewhere that serves food that feels like a hug. Don't say Zingerman's — I need something I can actually afford on a Tuesday 😅",
    author_id: "demo-user-10",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 1 * DAY - 6 * HOUR).toISOString(),
    agree_count: 21,
    curious_count: 1,
    replies_count: 18,
    is_demo: true,
  },

  // ===== 🎉 EVENT/PROMO (3 posts) =====
  {
    id: "demo-post-ep-1",
    topic: "Event/Promo",
    action: "eventPromo",
    category: "eventPromo",
    title: "Free yoga in the park this Saturday! 🧘‍♀️",
    body: "Hosting a free community yoga session at West Park, 9am. All levels welcome. Bring your own mat. I'm a certified instructor and just want to give back to the community. See you there!",
    author_id: "demo-user-11",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 2 * HOUR).toISOString(),
    agree_count: 28,
    curious_count: 9,
    replies_count: 6,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400",
  },
  {
    id: "demo-post-ep-2",
    topic: "Event/Promo",
    action: "eventPromo",
    category: "eventPromo",
    body: "Our restaurant (Main St Diner) is doing 50% off all brunch items this Sunday to celebrate our 5th anniversary! First 20 customers get a free mimosa. Come say hi! 🥂",
    author_id: "demo-user-46",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 11 * HOUR).toISOString(),
    agree_count: 15,
    curious_count: 4,
    replies_count: 3,
    is_demo: true,
    thumbnail_url: "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=400",
  },
  {
    id: "demo-post-ep-3",
    topic: "Event/Promo",
    action: "eventPromo",
    category: "eventPromo",
    title: "Neighborhood garage sale — Old West Side",
    body: "20+ houses participating this weekend, Saturday 8am-2pm. Furniture, vintage clothes, kids stuff, records, you name it. Maps available at the corner of Madison & 7th.",
    author_id: "demo-user-22",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(NOW - 3 * DAY).toISOString(),
    agree_count: 33,
    curious_count: 7,
    replies_count: 5,
    is_demo: true,
  },

  // ===== LEGACY POSTS (kept for backward compat) =====
  {
    id: "demo-post-2",
    topic: "Local Announce",
    action: "hobbies",
    category: "hobbies",
    title: "Looking for people to grab a beer (or seltzer) this weekend!",
    body: "DM me, now!!\n\n😊 Anyone can join!\n🎯 2/4 Spots",
    author_id: "demo-user-5",
    area: "Kerrytown, Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    place_name: "YoyoMa · Kerrytown, Ann Arbor",
    status: "Open",
    created_at: new Date(Date.now() - 3 * 60 * 1000).toISOString(),
    agree_count: 5,
    curious_count: 2,
    replies_count: 0,
    is_demo: true,
  },
  {
    id: "demo-post-3",
    topic: "Local Eats",
    action: "localInfo",
    category: "localInfo",
    body: "Where are the best spots for solo dining? I'm trying to build a list of places where you don't feel awkward or like you're taking up a table. Any suggestions welcome!",
    author_id: "demo-user-4",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    created_at: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    agree_count: 0,
    curious_count: 0,
    replies_count: 2,
    is_demo: true,
  },
  {
    id: "demo-post-5",
    topic: "Lost & Found",
    action: "help",
    category: "help",
    title: "Lost Card Wallet",
    body: "I lost my card wallet. I will offer a cash reward if found. Please help me find it.\nNear Briarwood Mall, Ann Arbor",
    author_id: "demo-user-6",
    area: "Ann Arbor",
    county: "Washtenaw",
    city: "Ann Arbor",
    place_name: "Pearly Gates\nBriarwood Mall, Ann Arbor",
    status: "Seeking",
    images: [
      "https://images.unsplash.com/photo-1627123424574-724758594e93?w=400",
      "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400",
    ],
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    agree_count: 0,
    curious_count: 0,
    replies_count: 0,
    is_demo: true,
  },
];

export const DEMO_AUTHORS: Record<string, { name: string; username: string; county: string }> = {
  "demo-user-1": { name: "Joseph", username: "joseph_trades", county: "Ann Arbor" },
  "demo-user-2": { name: "Emily", username: "emily_beauty", county: "Washtenaw" },
  "demo-user-3": { name: "Kari", username: "kari_foodie", county: "Ann Arbor" },
  "demo-user-4": { name: "Kristin", username: "kristin_local", county: "Ann Arbor" },
  "demo-user-5": { name: "YoyoMa", username: "yoyoma_music", county: "Ann Arbor" },
  "demo-user-6": { name: "Maro", username: "maro_tech", county: "Ann Arbor" },
  // Diverse community members
  "demo-user-10": { name: "Sujin", username: "raindrop_sj", county: "Washtenaw" },
  "demo-user-11": { name: "Tasha", username: "nightowl_t", county: "Washtenaw" },
  "demo-user-13": { name: "Linnea", username: "mossfern_l", county: "Washtenaw" },
  "demo-user-14": { name: "Diego", username: "ember_d", county: "Washtenaw" },
  "demo-user-15": { name: "Yuna", username: "stardrift_y", county: "Washtenaw" },
  "demo-user-16": { name: "Caleb", username: "foglight_c", county: "Washtenaw" },
  "demo-user-17": { name: "Amira", username: "velvetdusk", county: "Washtenaw" },
  "demo-user-19": { name: "Mei-Lin", username: "cloudpine", county: "Washtenaw" },
  "demo-user-20": { name: "Oscar", username: "saltbreeze_o", county: "Washtenaw" },
  "demo-user-22": { name: "Benny", username: "oakstone_b", county: "Washtenaw" },
  "demo-user-23": { name: "Sol", username: "driftwind", county: "Washtenaw" },
  "demo-user-24": { name: "Reese", username: "nightbloom_r", county: "Washtenaw" },
  "demo-user-25": { name: "Dani", username: "pebbletide", county: "Washtenaw" },
  "demo-user-26": { name: "Jin", username: "starfall_j", county: "Washtenaw" },
  "demo-user-28": { name: "Rowan", username: "frostbyte_r", county: "Washtenaw" },
  "demo-user-30": { name: "Marcus", username: "hazelvine_m", county: "Washtenaw" },
  "demo-user-31": { name: "Zoe", username: "moonlark_z", county: "Washtenaw" },
  "demo-user-32": { name: "Aiden", username: "cedarknot_a", county: "Washtenaw" },
  "demo-user-33": { name: "Priya", username: "golddust_p", county: "Washtenaw" },
  "demo-user-34": { name: "Liam", username: "steelwave", county: "Washtenaw" },
  // New diverse authors
  "demo-user-40": { name: "Gerald", username: "jerry_ward5", county: "Washtenaw" },
  "demo-user-41": { name: "Alyssa", username: "lyssa_alum", county: "Washtenaw" },
  "demo-user-42": { name: "Frank", username: "frank_sparks", county: "Washtenaw" },
  "demo-user-43": { name: "Kenji", username: "kenji_newbie", county: "Washtenaw" },
  "demo-user-44": { name: "Harold", username: "grandpa_hal", county: "Washtenaw" },
  "demo-user-45": { name: "Dr. Patel", username: "prof_patel", county: "Washtenaw" },
  "demo-user-46": { name: "Lisa", username: "mainst_diner", county: "Washtenaw" },
};

// Demo chat conversations for the Chat page
export const DEMO_CHAT_CONVERSATIONS = [
  {
    id: 'demo-chat-1',
    participants: [{ user_id: 'demo' }, { user_id: 'joseph' }],
    last_message: 'Thank you!! Drive safe!',
    last_message_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'joseph',
      name: 'Joseph',
      county: 'Ann Arbor',
      avatar_url: josephAvatar
    },
    listing: {
      images: [item1]
    }
  },
  {
    id: 'demo-chat-2',
    participants: [{ user_id: 'demo' }, { user_id: 'yoiki' }],
    last_message: 'Just checked it! Thank you :)',
    last_message_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'yoiki',
      name: 'Yoiki',
      county: 'Detroit',
      avatar_url: yoikiAvatar
    },
    listing: {
      images: [item2]
    }
  },
  {
    id: 'demo-chat-3',
    participants: [{ user_id: 'demo' }, { user_id: 'chan' }],
    last_message: 'Yup! My pleasure!',
    last_message_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'chan',
      name: 'chan',
      county: 'Dearborn',
      avatar_url: chanAvatar
    },
    listing: {
      images: [item3]
    }
  },
  {
    id: 'demo-chat-4',
    participants: [{ user_id: 'demo' }, { user_id: 'prof' }],
    last_message: "I'm so sorry, this is a super late reply...",
    last_message_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'prof',
      name: 'EECS Prof',
      county: 'Ann Arbor',
      avatar_url: profAvatar
    },
    listing: {
      images: ['🎧']
    }
  },
  {
    id: 'demo-chat-5',
    participants: [{ user_id: 'demo' }, { user_id: 'msquad' }],
    last_message: 'M squad sent an emoji.',
    last_message_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'msquad',
      name: 'M squad',
      county: 'Ann Arbor',
      avatar_url: yoikiAvatar
    },
    listing: {
      images: ['💄']
    }
  },
  {
    id: 'demo-chat-6',
    participants: [{ user_id: 'demo' }, { user_id: 'kenny' }],
    last_message: 'yes. Willing to buy?',
    last_message_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'kenny',
      name: 'kenny',
      county: 'Belleville',
      avatar_url: yoikiAvatar
    },
    listing: {
      images: ['📷']
    }
  },
  {
    id: 'demo-chat-7',
    participants: [{ user_id: 'demo' }, { user_id: 'mojo' }],
    last_message: 'Mojo Lover sent an emoji.',
    last_message_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'mojo',
      name: 'Mojo Lover',
      county: 'Ann Arbor',
      avatar_url: mojoAvatar
    },
    listing: {
      images: ['💅']
    }
  },
  {
    id: 'demo-chat-8',
    participants: [{ user_id: 'demo' }, { user_id: 'freshman' }],
    last_message: 'M Freshman sent an emoji.',
    last_message_at: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'freshman',
      name: 'M Freshman',
      county: 'Ann Arbor',
      avatar_url: freshmanAvatar
    },
    listing: {
      images: ['👟']
    }
  },
  {
    id: 'demo-chat-9',
    participants: [{ user_id: 'demo' }, { user_id: 'ross' }],
    last_message: 'Great deal! Thx!',
    last_message_at: new Date(Date.now() - 210 * 24 * 60 * 60 * 1000).toISOString(),
    participant: {
      id: 'ross',
      name: "Ross '28",
      county: 'Allen Park',
      avatar_url: yoikiAvatar
    },
    listing: {
      images: ['🪴']
    }
  }
];

export function loadDemoData() {
  try {
    safeStorage.removeItem('gemu_demo_removed');
    safeStorage.setItem(DEMO_LISTINGS_KEY, JSON.stringify(DEMO_LISTINGS));
    safeStorage.setItem(DEMO_POSTS_KEY, JSON.stringify(DEMO_POSTS));
    safeStorage.setItem(DEMO_CHAT_CONVERSATIONS_KEY, JSON.stringify(DEMO_CHAT_CONVERSATIONS));
    toast.success("Demo data loaded ✅");
    window.location.reload();
  } catch (error) {
    toast.error("Failed to load demo data");
    console.error(error);
  }
}

// Auto-load demo data if not present - preserves user-added data
export function autoLoadDemoData() {
  try {
    // If user manually removed demo data, don't auto-reload it
    if (safeStorage.getItem('gemu_demo_removed') === 'true') {
      return;
    }

    const existingListings = safeStorage.getItem(DEMO_LISTINGS_KEY);
    const existingPosts = safeStorage.getItem(DEMO_POSTS_KEY);
    const currentVersion = safeStorage.getItem(DEMO_DATA_VERSION_KEY);

    // Force refresh if version changed
    if (currentVersion !== DEMO_DATA_VERSION) {
      safeStorage.setItem(DEMO_LISTINGS_KEY, JSON.stringify(DEMO_LISTINGS));
      safeStorage.setItem(DEMO_POSTS_KEY, JSON.stringify(DEMO_POSTS));
      safeStorage.setItem(DEMO_DATA_VERSION_KEY, DEMO_DATA_VERSION);
      return;
    }

    // Only load if completely empty
    if (!existingListings) {
      safeStorage.setItem(DEMO_LISTINGS_KEY, JSON.stringify(DEMO_LISTINGS));
    } else {
      // Check if we need to merge with demo data (only if user has added data)
      const currentListings = JSON.parse(existingListings);
      const hasUserData = currentListings.some((l: any) => 
        !l.id.startsWith('demo-listing-')
      );
      
      // If user has added data, preserve it and don't overwrite
      if (!hasUserData && currentListings.length < DEMO_LISTINGS.length) {
        safeStorage.setItem(DEMO_LISTINGS_KEY, JSON.stringify(DEMO_LISTINGS));
      }
    }
    
    if (!existingPosts) {
      safeStorage.setItem(DEMO_POSTS_KEY, JSON.stringify(DEMO_POSTS));
    }
  } catch (error) {
    console.error("Failed to auto-load demo data:", error);
  }
}

export function removeDemoData() {
  try {
    safeStorage.removeItem(DEMO_LISTINGS_KEY);
    safeStorage.removeItem(DEMO_POSTS_KEY);
    safeStorage.removeItem(DEMO_CHAT_CONVERSATIONS_KEY);
    // Mark as manually removed so autoLoadDemoData won't re-add it
    safeStorage.setItem('gemu_demo_removed', 'true');
    toast.success("Demo data cleared 🗑️");
    window.location.reload();
  } catch (error) {
    toast.error("Failed to remove demo data");
    console.error(error);
  }
}

export function getDemoChatConversations() {
  try {
    const data = safeStorage.getItem(DEMO_CHAT_CONVERSATIONS_KEY);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error("Error getting demo chat conversations:", error);
    return [];
  }
}

export function getDemoListings() {
  try {
    const data = safeStorage.getItem(DEMO_LISTINGS_KEY);
    const listings = data ? JSON.parse(data) : [];
    
    // Add views count to each listing
    return listings.map((listing: any) => ({
      ...listing,
      views: getDemoViewCount(listing.id)
    }));
  } catch (error) {
    console.error("Error getting demo listings:", error);
    return [];
  }
}

export function getDemoPosts() {
  try {
    const data = safeStorage.getItem(DEMO_POSTS_KEY);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error("Error getting demo posts:", error);
    return [];
  }
}

export function addDemoListing(listing: any) {
  try {
    const listings = getDemoListings();
    // Add new listing at the beginning (맨 위에 추가)
    const updatedListings = [listing, ...listings];
    safeStorage.setItem(DEMO_LISTINGS_KEY, JSON.stringify(updatedListings));
    return true;
  } catch (error) {
    console.error("❌ Error adding demo listing:", error);
    return false;
  }
}

export function addDemoPost(post: any) {
  try {
    const posts = getDemoPosts();
    // Add new post at the beginning (맨 위에 추가)
    const updatedPosts = [post, ...posts];
    safeStorage.setItem(DEMO_POSTS_KEY, JSON.stringify(updatedPosts));
    return true;
  } catch (error) {
    console.error("❌ Error adding demo post:", error);
    return false;
  }
}

export function deleteDemoPostsByTitle(titlePattern: string) {
  try {
    const posts = getDemoPosts();
    const filteredPosts = posts.filter((post: any) => 
      !post.title?.includes(titlePattern) && !post.body?.includes(titlePattern)
    );
    safeStorage.setItem(DEMO_POSTS_KEY, JSON.stringify(filteredPosts));
    const deletedCount = posts.length - filteredPosts.length;
    return deletedCount;
  } catch (error) {
    console.error("❌ Error deleting demo posts:", error);
    return 0;
  }
}

// Demo interactions management
const DEMO_LIKES_KEY = "gemurhood_demo_likes";
const DEMO_COMMENTS_KEY = "gemurhood_demo_comments";
const DEMO_VIEWS_KEY = "gemurhood_demo_views";

// Likes
export function toggleDemoLike(listingId: string, userId: string) {
  try {
    const likesStr = safeStorage.getItem(DEMO_LIKES_KEY, '{}');
    const likes = JSON.parse(likesStr || '{}');
    if (!likes[listingId]) likes[listingId] = {};
    
    const isLiked = likes[listingId][userId];
    if (isLiked) {
      delete likes[listingId][userId];
    } else {
      likes[listingId][userId] = true;
    }
    
    safeStorage.setItem(DEMO_LIKES_KEY, JSON.stringify(likes));
    
    // Update listing likes count
    const listings = getDemoListings();
    const listing = listings.find((l: any) => l.id === listingId);
    if (listing) {
      const likeCount = Object.keys(likes[listingId] || {}).length;
      listing.likes = likeCount;
      safeStorage.setItem(DEMO_LISTINGS_KEY, JSON.stringify(listings));
    }
    
    return !isLiked;
  } catch (error) {
    console.error("Error toggling demo like:", error);
    return false;
  }
}

export function getDemoLikeStatus(listingId: string, userId: string) {
  try {
    const likesStr = safeStorage.getItem(DEMO_LIKES_KEY, '{}');
    const likes = JSON.parse(likesStr || '{}');
    return !!(likes[listingId]?.[userId]);
  } catch (error) {
    return false;
  }
}

export function getDemoLikeCount(listingId: string) {
  try {
    const likesStr = safeStorage.getItem(DEMO_LIKES_KEY, '{}');
    const likes = JSON.parse(likesStr || '{}');
    return Object.keys(likes[listingId] || {}).length;
  } catch (error) {
    return 0;
  }
}

// Views
export function incrementDemoView(listingId: string) {
  try {
    const viewsStr = safeStorage.getItem(DEMO_VIEWS_KEY, '{}');
    const views = JSON.parse(viewsStr || '{}');
    views[listingId] = (views[listingId] || 0) + 1;
    safeStorage.setItem(DEMO_VIEWS_KEY, JSON.stringify(views));
    return views[listingId];
  } catch (error) {
    console.error("Error incrementing demo view:", error);
    return 0;
  }
}

export function getDemoViewCount(listingId: string) {
  try {
    const viewsStr = safeStorage.getItem(DEMO_VIEWS_KEY, '{}');
    const views = JSON.parse(viewsStr || '{}');
    return views[listingId] || 0;
  } catch (error) {
    return 0;
  }
}

// Comments
export function addDemoComment(listingId: string, comment: any) {
  try {
    const commentsStr = safeStorage.getItem(DEMO_COMMENTS_KEY, '{}');
    const comments = JSON.parse(commentsStr || '{}');
    if (!comments[listingId]) comments[listingId] = [];
    comments[listingId].push(comment);
    safeStorage.setItem(DEMO_COMMENTS_KEY, JSON.stringify(comments));
    return true;
  } catch (error) {
    console.error("Error adding demo comment:", error);
    return false;
  }
}

export function getDemoComments(listingId: string) {
  try {
    const commentsStr = safeStorage.getItem(DEMO_COMMENTS_KEY, '{}');
    const comments = JSON.parse(commentsStr || '{}');
    return comments[listingId] || [];
  } catch (error) {
    return [];
  }
}

export function updateDemoComment(listingId: string, commentId: string, text: string) {
  try {
    const commentsStr = safeStorage.getItem(DEMO_COMMENTS_KEY, '{}');
    const comments = JSON.parse(commentsStr || '{}');
    const listingComments = comments[listingId] || [];
    
    const updateComment = (items: any[]): boolean => {
      for (let item of items) {
        if (item.id === commentId) {
          item.text = text;
          item.updated_at = new Date().toISOString();
          return true;
        }
        if (item.replies && updateComment(item.replies)) {
          return true;
        }
      }
      return false;
    };
    
    updateComment(listingComments);
    comments[listingId] = listingComments;
    safeStorage.setItem(DEMO_COMMENTS_KEY, JSON.stringify(comments));
    return true;
  } catch (error) {
    console.error("Error updating demo comment:", error);
    return false;
  }
}

export function deleteDemoComment(listingId: string, commentId: string) {
  try {
    const commentsStr = safeStorage.getItem(DEMO_COMMENTS_KEY, '{}');
    const comments = JSON.parse(commentsStr || '{}');
    const listingComments = comments[listingId] || [];
    
    const deleteComment = (items: any[]): any[] => {
      return items.filter(item => {
        if (item.id === commentId) return false;
        if (item.replies) {
          item.replies = deleteComment(item.replies);
        }
        return true;
      });
    };
    
    comments[listingId] = deleteComment(listingComments);
    safeStorage.setItem(DEMO_COMMENTS_KEY, JSON.stringify(comments));
    return true;
  } catch (error) {
    console.error("Error deleting demo comment:", error);
    return false;
  }
}

// User-specific data
export function getUserDemoListings(userId: string) {
  try {
    const listings = getDemoListings();
    return listings.filter((l: any) => l.seller_id === userId);
  } catch (error) {
    console.error("Error getting user demo listings:", error);
    return [];
  }
}

export function getUserDemoLikes(userId: string) {
  try {
    const likesStr = safeStorage.getItem(DEMO_LIKES_KEY, '{}');
    const likes = JSON.parse(likesStr || '{}');
    const likedListingIds: string[] = [];
    
    for (const listingId in likes) {
      if (likes[listingId][userId]) {
        likedListingIds.push(listingId);
      }
    }
    
    const listings = getDemoListings();
    return listings.filter((l: any) => likedListingIds.includes(l.id));
  } catch (error) {
    console.error("Error getting user demo likes:", error);
    return [];
  }
}

// Demo conversations management
const DEMO_CONVERSATIONS_KEY = "gemurhood_demo_conversations";
const DEMO_MESSAGES_KEY = "gemurhood_demo_messages";

export function createDemoConversation(userId: string, sellerId: string, listingId: string) {
  try {
    const conversationsStr = safeStorage.getItem(DEMO_CONVERSATIONS_KEY, '{}');
    const conversations = JSON.parse(conversationsStr || '{}');
    
    // Check if conversation already exists
    const existingId = Object.keys(conversations).find(convId => {
      const conv = conversations[convId];
      const ids = (conv.participants || []).map((p: any) => p.user_id);
      return ids.includes(userId) && ids.includes(sellerId);
    });

    if (existingId) {
      return existingId;
    }

    // Create new conversation
    const convId = `demo-conv-${Date.now()}`;
    conversations[convId] = {
      id: convId,
      participants: [{ user_id: userId }, { user_id: sellerId }],
      listing_id: listingId,
      created_at: new Date().toISOString(),
      last_message_at: new Date().toISOString(),
      last_message: 'Started a conversation',
    };
    
    safeStorage.setItem(DEMO_CONVERSATIONS_KEY, JSON.stringify(conversations));
    
    // Initialize messages for this conversation
    const messagesStr = safeStorage.getItem(DEMO_MESSAGES_KEY, '{}');
    const messages = JSON.parse(messagesStr || '{}');
    messages[convId] = [];
    safeStorage.setItem(DEMO_MESSAGES_KEY, JSON.stringify(messages));
    
    return convId;
  } catch (error) {
    console.error("Error creating demo conversation:", error);
    return null;
  }
}

export function getDemoConversations(userId: string) {
  try {
    const conversationsStr = safeStorage.getItem(DEMO_CONVERSATIONS_KEY, '{}');
    const conversations = JSON.parse(conversationsStr || '{}');
    return Object.values(conversations).filter((conv: any) =>
      (conv.participants || []).some((p: any) => p.user_id === userId)
    );
  } catch (error) {
    console.error("Error getting demo conversations:", error);
    return [];
  }
}

export function getDemoConversation(convId: string) {
  try {
    const conversationsStr = safeStorage.getItem(DEMO_CONVERSATIONS_KEY, '{}');
    const conversations = JSON.parse(conversationsStr || '{}');
    return conversations[convId] || null;
  } catch (error) {
    console.error("Error getting demo conversation:", error);
    return null;
  }
}

export function addDemoMessage(convId: string, senderId: string, text: string, attachments: string[] = []) {
  try {
    const messagesStr = safeStorage.getItem(DEMO_MESSAGES_KEY, '{}');
    const messages = JSON.parse(messagesStr || '{}');
    if (!messages[convId]) messages[convId] = [];
    
    const message = {
      id: `demo-msg-${Date.now()}`,
      conversation_id: convId,
      sender_id: senderId,
      text,
      attachments,
      created_at: new Date().toISOString(),
      read: false,
    };
    
    messages[convId].push(message);
    safeStorage.setItem(DEMO_MESSAGES_KEY, JSON.stringify(messages));
    
    // Update conversation last_message
    const conversationsStr = safeStorage.getItem(DEMO_CONVERSATIONS_KEY, '{}');
    const conversations = JSON.parse(conversationsStr || '{}');
    if (conversations[convId]) {
      conversations[convId].last_message = text;
      conversations[convId].last_message_at = new Date().toISOString();
      safeStorage.setItem(DEMO_CONVERSATIONS_KEY, JSON.stringify(conversations));
    }
    
    return message;
  } catch (error) {
    console.error("Error adding demo message:", error);
    return null;
  }
}

export function getDemoMessages(convId: string) {
  try {
    const messagesStr = safeStorage.getItem(DEMO_MESSAGES_KEY, '{}');
    const messages = JSON.parse(messagesStr || '{}');
    return messages[convId] || [];
  } catch (error) {
    console.error("Error getting demo messages:", error);
    return [];
  }
}

export function deleteDemoMessage(convId: string, messageId: string) {
  try {
    const messagesStr = safeStorage.getItem(DEMO_MESSAGES_KEY, '{}');
    const messages = JSON.parse(messagesStr || '{}');
    if (messages[convId]) {
      messages[convId] = messages[convId].filter((msg: any) => msg.id !== messageId);
      safeStorage.setItem(DEMO_MESSAGES_KEY, JSON.stringify(messages));
      return true;
    }
    return false;
  } catch (error) {
    console.error("Error deleting demo message:", error);
    return false;
  }
}

export function getUserDemoComments(userId: string) {
  try {
    const commentsStr = safeStorage.getItem(DEMO_COMMENTS_KEY, '{}');
    const allComments = JSON.parse(commentsStr || '{}');
    const userComments: any[] = [];
    
    for (const listingId in allComments) {
      const comments = allComments[listingId] || [];
      const findUserComments = (items: any[]) => {
        for (const comment of items) {
          if (comment.user_id === userId) {
            userComments.push({
              ...comment,
              target_id: listingId,
              target_type: 'listing'
            });
          }
          if (comment.replies) {
            findUserComments(comment.replies);
          }
        }
      };
      findUserComments(comments);
    }
    
    return userComments;
  } catch (error) {
    console.error("Error getting user demo comments:", error);
    return [];
  }
}

export function deleteDemoListing(listingId: string) {
  try {
    const listings = getDemoListings();
    const updatedListings = listings.filter((l: any) => l.id !== listingId);
    safeStorage.setItem(DEMO_LISTINGS_KEY, JSON.stringify(updatedListings));
    return true;
  } catch (error) {
    console.error("Error deleting demo listing:", error);
    return false;
  }
}

export const DEMO_NOTIFICATIONS = [
  {
    id: "demo-notif-1",
    type: "transaction",
    title: "Transaction Confirmed! 🎉",
    message: "Your deal is confirmed! Check the meeting location with the seller.",
    link: "/chat",
    read: false,
    created_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), // 2 hours ago
  },
  {
    id: "demo-notif-2",
    type: "like",
    title: "3 people liked your listing!",
    message: "3 people saved your 'iPhone 13 Pro Max' listing 👀",
    link: "/my-listings",
    read: false,
    created_at: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(), // 5 hours ago
  },
  {
    id: "demo-notif-3",
    type: "price_drop",
    title: "Price Drop Alert! 💲",
    message: "Your saved 'Coffee Machine' dropped $20 in price!",
    link: "/watchlist",
    read: true,
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), // 1 day ago
  },
  {
    id: "demo-notif-4",
    type: "message",
    title: "New Message",
    message: "Mike Thompson sent you a new message about your listing.",
    link: "/chat",
    read: true,
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
  },
  {
    id: "demo-notif-5",
    type: "local_post",
    title: "New Post in Ann Arbor 📍",
    message: "A new popular listing was posted in Ann Arbor!",
    link: "/near-me",
    read: true,
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days ago
  },
  {
    id: "demo-notif-6",
    type: "comment",
    title: "New Comment on Your Listing",
    message: "Sarah Davis asked about the condition of your item.",
    link: "/my-listings",
    read: true,
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago
  },
  {
    id: "demo-notif-7",
    type: "trending",
    title: "Hot This Week in Ann Arbor 🔥",
    message: "Check out the 5 most popular listings in your neighborhood!",
    link: "/",
    read: true,
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 days ago
  },
  {
    id: "demo-notif-8",
    type: "system",
    title: "Verification Badge Activated ✔️",
    message: "Your identity verification badge is now active on your profile!",
    link: "/settings",
    read: true,
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), // 10 days ago
  },
];
